import { ROLES_LIST } from '@/js/constants';
export default [
/*{
  name: 'My Resources',
  key: 'menu.analytic.my_resources',
  subname: '',
  href: { name: 'MyResources' },
  link: '/resources/MyResources',
  roles: [ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ML_STEWARD]
},
{
  name: 'Resources requests',
  key: 'menu.analytic.resources_requests',
  href: { name: 'ContResourcesRequest' },
  link: '/resources/ContResourcesRequest',
  roles: [ROLES_LIST.ML_STEWARD]
},*/
/*{
  name: 'Pipelines',
  key: 'menu.analytic.pipelines',
  href: { name: 'MlOpsCreate' },
  link: '/MlOps/create',
  roles: [ROLES_LIST.ML_STEWARD]
},
{
  name: 'Resources',
  key: 'menu.analytic.resource',
  href: { name: 'TableCreate' },
  link: '/MlOps/TableCreate',
  roles: [ROLES_LIST.ML_STEWARD]
},*/
{
  name: 'ML Ops',
  icon: 'mdi-pipe',
  key: 'menu.analytic.ml_ops',
  href: {
    name: 'MlopsConfigs'
  },
  link: '/MlOps/Configs',
  roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ORG_DATA_STEWARD],
  check_flag: 'analytic-services/has_mlops_active',
  subItems: [{
    name: 'ML Configs',
    key: 'menu.analytic.ml_configs',
    href: {
      name: 'MlopsConfigs'
    },
    link: '/MlOps/Configs',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: 'analytic-services/has_mlops_active'
  }, {
    name: 'ML Projects',
    key: 'menu.analytic.ml_projects',
    href: {
      name: 'MlopsProjects'
    },
    link: '/MlOps/Projects',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: 'analytic-services/has_mlops_active'
  }, {
    name: 'ML Requests',
    key: 'menu.analytic.ml_requests',
    href: {
      name: 'MLRequests'
    },
    link: '/ml/requests',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: 'analytic-services/has_mlops_active'
  }, {
    name: 'Pipelines',
    key: 'menu.analytic.ml_pipelines',
    href: {
      name: 'MLComponents'
    },
    link: '/ml/pipelines',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: 'analytic-services/has_mlops_active'
  }
  /*{
    name: 'Builder',
    key: 'menu.analytic.ml_builder',
    href: { name: 'MLBuilder' },
    link: '/ml/builder',
    roles: [ROLES_LIST.ML_STEWARD, ROLES_LIST.ML_DEVELOPER, ROLES_LIST.ORG_DATA_STEWARD],
    check_flag: 'analytic-services/has_mlops_active'
  },*/]
}];